export const FULL_DATA = {
    "DATA": [
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 446070863,
        "Site": "Andover",
        "Service Type": "DIA",
        "Exp Date": 46593,
        "SO Found": "NA",
        "MRC base": 1470.95,
        "MRC w/tax & fees": 1684.11,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "2 Technology Drive",
        "Address 2": "NA",
        "Abbreviation": "2TDR",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2625269,
        "Service/Circuit ID": 2921046,
        "Site": "Andover",
        "Service Type": "SDWAN",
        "Exp Date": 46620,
        "SO Found": "NA",
        "MRC base": 1926,
        "MRC w/tax & fees": 1926,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "2 Tech Drive",
        "Address 2": "NA",
        "Abbreviation": "2TDR",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2625269,
        "Service/Circuit ID": 2921046,
        "Site": "Andover",
        "Service Type": "MPLS",
        "Exp Date": 46620,
        "SO Found": "NA",
        "MRC base": 1161,
        "MRC w/tax & fees": 1758.76,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "2 Tech Drive",
        "Address 2": "NA",
        "Abbreviation": "2TDR",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 405.7668,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AICH"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 356.9724,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AICH"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2238752,
        "Service/Circuit ID": 2050820,
        "Site": "Andover",
        "Service Type": "SDWAN",
        "Exp Date": 45786,
        "SO Found": "GTT #1",
        "MRC base": 846,
        "MRC w/tax & fees": 846,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "6 Shattuck Rd",
        "Address 2": "NA",
        "Abbreviation": "AND",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2238752,
        "Service/Circuit ID": 2050820,
        "Site": "Andover",
        "Service Type": "MPLS",
        "Exp Date": 45786,
        "SO Found": "GTT #1",
        "MRC base": 4500,
        "MRC w/tax & fees": 5403.129999999999,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "6 Shattuck Rd",
        "Address 2": "NA",
        "Abbreviation": "AND",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454992,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 443217367,
        "Site": "Andover",
        "Service Type": "DIA",
        "Exp Date": "Exp 12/4/24",
        "SO Found": "NA",
        "MRC base": 2400.03,
        "MRC w/tax & fees": 2712.75,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "6 Shattuck Rd",
        "Address 2": "NA",
        "Abbreviation": "AND",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454992,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 446174091,
        "Site": "Andover",
        "Service Type": "DIA",
        "Exp Date": 46529,
        "SO Found": "NA",
        "MRC base": 2665,
        "MRC w/tax & fees": 3030.47,
        "Speed (mbps)": 2000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "6 Shattuck Rd",
        "Address 2": "NA",
        "Abbreviation": "AND",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454992,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 443146681,
        "Site": "Andover",
        "Service Type": "DIA",
        "Exp Date": "Exp 6/27/24",
        "SO Found": "NA",
        "MRC base": 2679.77,
        "MRC w/tax & fees": 3037.53,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "6 Shattuck Rd",
        "Address 2": "NA",
        "Abbreviation": "AND",
        "City": "Andover",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 278.1,
        "Speed (mbps)": 1000,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AND"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1736761,
        "Service/Circuit ID": 1890713,
        "Site": "Austin",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 7/19/23",
        "SO Found": "GTT #2",
        "MRC base": 665.58,
        "MRC w/tax & fees": 665.58,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "7800 Shoal Creek Blvd",
        "Address 2": "NA",
        "Abbreviation": "AUS",
        "City": "Austin",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 78757
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1736761,
        "Service/Circuit ID": 1890713,
        "Site": "Austin",
        "Service Type": "MPLS",
        "Exp Date": "Exp 7/19/23",
        "SO Found": "GTT #2",
        "MRC base": 519,
        "MRC w/tax & fees": 756.86,
        "Speed (mbps)": "10 or 20",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "7800 Shoal Creek Blvd",
        "Address 2": "NA",
        "Abbreviation": "AUS",
        "City": "Austin",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 78757
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "IP-MKS-9",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "TX/KXFN/339454/LVLC  442193342",
        "Site": "Austin",
        "Service Type": "DIA",
        "Exp Date": "Exp 6/24/24",
        "SO Found": "NA",
        "MRC base": 669,
        "MRC w/tax & fees": 792.77,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "Lumen",
        "Address Street/Suite": "7800 Shoal Creek Blvd",
        "Address 2": "NA",
        "Abbreviation": "AUS",
        "City": "Austin",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 78757
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Cloud Connect",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1392.8652000000002,
        "Speed (mbps)": 200,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AWS-FR"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Cloud Connect",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1349.9892000000002,
        "Speed (mbps)": 200,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AWS-NY"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Cloud Connect",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1473.8652000000002,
        "Speed (mbps)": 500,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "AWS-SG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BANG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BANG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "FXIP-MKS-3",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "FBLU1/IPAC/487668-1057549",
        "Site": "Beaune",
        "Service Type": "DIA",
        "Exp Date": 45659,
        "SO Found": "NA",
        "MRC base": 2799.45,
        "MRC w/tax & fees": 3037.4,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "GTT",
        "Address Street/Suite": "7 Rue des Plantes",
        "Address 2": "NA",
        "Abbreviation": "BEA",
        "City": "Beaune-la-Rolande",
        "Country": "France",
        "Postal Code": "01810"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2587443,
        "Service/Circuit ID": 1071947,
        "Site": "Beaune",
        "Service Type": "SDWAN",
        "Exp Date": 46468,
        "SO Found": "NA",
        "MRC base": 995.4,
        "MRC w/tax & fees": 995.4,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3 Rue des Plantes",
        "Address 2": "NA",
        "Abbreviation": "BEA",
        "City": "Beaune-la-Rolande",
        "Country": "France",
        "Postal Code": 45340
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2587443,
        "Service/Circuit ID": 1071947,
        "Site": "Beaune",
        "Service Type": "MPLS",
        "Exp Date": 46468,
        "SO Found": "NA",
        "MRC base": 845.49,
        "MRC w/tax & fees": 1120.71,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3 Rue des Plantes",
        "Address 2": "NA",
        "Abbreviation": "BEA",
        "City": "Beaune-la-Rolande",
        "Country": "France",
        "Postal Code": 45340
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 4452100290,
        "Site": "Beaune",
        "Service Type": "DIA",
        "Exp Date": 46389,
        "SO Found": "NA",
        "MRC base": 825,
        "MRC w/tax & fees": 825,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "3 Rue des Plantes",
        "Address 2": "NA",
        "Abbreviation": "BEA",
        "City": "Beaune-la-Rolande",
        "Country": "France",
        "Postal Code": 45340
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344771,
        "Service/Circuit ID": 1070246,
        "Site": "Berlin",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 805.66,
        "MRC w/tax & fees": 805.66,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Wattstrasse 13",
        "Address 2": "NA",
        "Abbreviation": "BER",
        "City": "Berlin",
        "Country": "Germany",
        "Postal Code": 13355
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2368271,
        "Service/Circuit ID": 972075,
        "Site": "Berlin",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 683.1,
        "MRC w/tax & fees": 905.6600000000001,
        "Speed (mbps)": "10 ??",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Wattstrasse 13",
        "Address 2": "NA",
        "Abbreviation": "BER",
        "City": "Berlin",
        "Country": "Germany",
        "Postal Code": 13355
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1482.786,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BKOK"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 696.1680000000001,
        "Speed (mbps)": 35,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BKOK"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2449487,
        "Service/Circuit ID": 1071953,
        "Site": "Boulonnie",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 11/4/23",
        "SO Found": "NA",
        "MRC base": 836.9,
        "MRC w/tax & fees": 836.9,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "9 Rue du Bois Sauvage",
        "Address 2": "La Boulonnie 16420",
        "Abbreviation": "BOU",
        "City": "Brigueuil",
        "Country": "France",
        "Postal Code": 16420
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636942,
        "Service/Circuit ID": 1603384,
        "Site": "Boulonnie",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 969.7,
        "MRC w/tax & fees": 1239.78,
        "Speed (mbps)": 4,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "9 Rue du Bois Sauvage",
        "Address 2": "La Boulonnie 16420",
        "Abbreviation": "BOU",
        "City": "Brigueuil",
        "Country": "France",
        "Postal Code": 16420
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2245425,
        "Service/Circuit ID": 2462093,
        "Site": "Bozeman",
        "Service Type": "SDWAN",
        "Exp Date": 45950,
        "SO Found": "NA",
        "MRC base": 398,
        "MRC w/tax & fees": 398,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "151 Evergreen Drive",
        "Address 2": "Suite D",
        "Abbreviation": "BOZ",
        "City": "Bozeman",
        "State/Prov": "MT",
        "Country": "USA",
        "Postal Code": 59715
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": 2245425,
        "Service/Circuit ID": 2462093,
        "Site": "Bozeman",
        "Service Type": "MPLS",
        "Exp Date": 45950,
        "SO Found": "NA",
        "MRC base": 2266,
        "MRC w/tax & fees": 2664.27,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "151 Evergreen Drive",
        "Address 2": "Suite D",
        "Abbreviation": "BOZ",
        "City": "Bozeman",
        "State/Prov": "MT",
        "Country": "USA",
        "Postal Code": 59715
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 343.3968,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BRLN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1065.42,
        "Speed (mbps)": 300,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BRLN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2246629,
        "Service/Circuit ID": 1859787,
        "Site": "Broomfield",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 12/16/23",
        "SO Found": "NA",
        "MRC base": 1096,
        "MRC w/tax & fees": 1096,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "11380 Reed Way",
        "Address 2": "NA",
        "Abbreviation": "BRM",
        "City": "Broomfield",
        "State/Prov": "CO",
        "Country": "USA",
        "Postal Code": 80020
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2246629,
        "Service/Circuit ID": 1859787,
        "Site": "Broomfield",
        "Service Type": "MPLS",
        "Exp Date": "Exp 12/16/23",
        "SO Found": "NA",
        "MRC base": 1767.14,
        "MRC w/tax & fees": 2295.5299999999997,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "11380 Reed Way",
        "Address 2": "NA",
        "Abbreviation": "BRM",
        "City": "Broomfield",
        "State/Prov": "CO",
        "Country": "USA",
        "Postal Code": 80020
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "IP-MKS-8",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442196345,
        "Site": "Broomfield",
        "Service Type": "DIA",
        "Exp Date": "Exp 10/15/24",
        "SO Found": "NA",
        "MRC base": 1543,
        "MRC w/tax & fees": 1825.03,
        "Speed (mbps)": 300,
        "Provider": "Fastblue",
        "Telco": "Lumen",
        "Address Street/Suite": "11250 Reed Way",
        "Address 2": "NA",
        "Abbreviation": "BRM",
        "City": "Broomfield",
        "State/Prov": "CO",
        "Country": "USA",
        "Postal Code": 80020
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344775,
        "Service/Circuit ID": 1432160,
        "Site": "Bucuresti",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 742.41,
        "MRC w/tax & fees": 742.41,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Strada Răcari 5",
        "Address 2": "Building 51B , 1st Floor, 3rd District",
        "Abbreviation": "BUC",
        "City": "București",
        "Country": "Romania",
        "Postal Code": "031828"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2637202,
        "Service/Circuit ID": 1347818,
        "Site": "Bucuresti",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 492.27,
        "MRC w/tax & fees": 789.28,
        "Speed (mbps)": 50,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Strada Răcari 5",
        "Address 2": "Building 51B , 1st Floor, 3rd District",
        "Abbreviation": "BUC",
        "City": "București",
        "Country": "Romania",
        "Postal Code": "031828"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2637072,
        "Service/Circuit ID": 1331921,
        "Site": "Bucuresti",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 752.1,
        "MRC w/tax & fees": 752.1,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Strada Răcari 5",
        "Address 2": "Building 51B , 1st Floor, 3rd District",
        "Abbreviation": "BUC",
        "City": "București",
        "Country": "Romania",
        "Postal Code": "031828"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2610789,
        "Service/Circuit ID": 1072247,
        "Site": "Catelu Romania",
        "Service Type": "SDWAN/Wireless",
        "Exp Date": 46648,
        "SO Found": "NA",
        "MRC base": 2016,
        "MRC w/tax & fees": 2016,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Bulevardul Theodor Pallady",
        "Address 2": "NA",
        "Abbreviation": "BUCA",
        "State/Prov": "Catelu",
        "Country": "Romania",
        "Postal Code": "077105"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2610789,
        "Service/Circuit ID": 1072247,
        "Site": "Catelu Romania",
        "Service Type": "DIA?",
        "Exp Date": 46648,
        "SO Found": "NA",
        "MRC base": 470,
        "MRC w/tax & fees": 702.94,
        "Speed (mbps)": 500,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Bulevardul Theodor Pallady",
        "Address 2": "NA",
        "Abbreviation": "BUCA",
        "State/Prov": "Catelu",
        "Country": "Romania",
        "Postal Code": "077105"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 538.596,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BURL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 750.6,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "BURL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Electro Scientific Industries",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1731201,
        "Service/Circuit ID": 1914479,
        "Site": "Beaverton",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 2/27/24",
        "SO Found": "NA",
        "MRC base": 1808,
        "MRC w/tax & fees": 1808,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "14523 SW Millikan Way",
        "Address 2": "NA",
        "Abbreviation": "BVT",
        "City": "Beaverton",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": 97005
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Electro Scientific Industries",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1731201,
        "Service/Circuit ID": 1914479,
        "Site": "Beaverton",
        "Service Type": "MPLS",
        "Exp Date": "Exp 2/27/24",
        "SO Found": "NA",
        "MRC base": 1934.8,
        "MRC w/tax & fees": 2494.35,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "14523 SW Millikan Way",
        "Address 2": "NA",
        "Abbreviation": "BVT",
        "City": "Beaverton",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": 97005
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Electro Scientific Industries",
        "Billing Account#": "5-MLPTCKCC",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442398896,
        "Site": "Beaverton",
        "Service Type": "DIA",
        "Exp Date": "TBD upgrade pending",
        "SO Found": "NA",
        "MRC base": 1217.41,
        "MRC w/tax & fees": 1328.07,
        "Speed (mbps)": 500,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "14523 SW Millikan Way",
        "Address 2": "NA",
        "Abbreviation": "BVT",
        "City": "Beaverton",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": 97005
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2419122,
        "Service/Circuit ID": 1674737,
        "Site": "Carmiel",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 8/1/23",
        "SO Found": "NA",
        "MRC base": 389.85,
        "MRC w/tax & fees": 448.13,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "34 Hanapah Street",
        "Address 2": "NA",
        "Abbreviation": "CAR",
        "City": "Carmiel",
        "Country": "Israel",
        "Postal Code": "2165377"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 109025660,
        "Site": "Carmiel",
        "Service Type": "DIA",
        "SO Found": "NA",
        "MRC base": 458,
        "MRC w/tax & fees": 458,
        "Speed (mbps)": 100,
        "Provider": "Partner.co.il",
        "Telco": "Partner.co.il",
        "Address Street/Suite": "34 Hanapah Street",
        "Address 2": "NA",
        "Abbreviation": "CAR",
        "City": "Carmiel",
        "Country": "Israel",
        "Postal Code": "2165377"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "3330010979",
        "Site": "Carmiel",
        "Service Type": "DIA",
        "SO Found": "NA",
        "MRC base": 209,
        "MRC w/tax & fees": 209,
        "Speed (mbps)": 50,
        "Provider": "Cellcom",
        "Telco": "Cellcom",
        "Address Street/Suite": "34 Hanapah Street",
        "Address 2": "NA",
        "Abbreviation": "CAR",
        "City": "Carmiel",
        "Country": "Israel",
        "Postal Code": "2165377"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2467.5948000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "CHNG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 542.376,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "CHNG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2554887,
        "Service/Circuit ID": 1070275,
        "Site": "Crewe",
        "Service Type": "SDWAN",
        "Exp Date": 46468,
        "SO Found": "NA",
        "MRC base": 1723.57,
        "MRC w/tax & fees": 1713.57,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "2 Cowley Way",
        "Address 2": "Weston Road",
        "Abbreviation": "CREWE",
        "City": "Crewe",
        "State/Prov": "Cheshire",
        "Country": "United Kingdom",
        "Postal Code": "CW1 6AG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344391,
        "Service/Circuit ID": 1009542,
        "Site": "Crewe",
        "Service Type": "MPLS",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 767.34,
        "MRC w/tax & fees": 1297.54,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "2 Cowley Way",
        "Address 2": "Weston Road",
        "Abbreviation": "CREWE",
        "City": "Crewe",
        "State/Prov": "Cheshire",
        "Country": "United Kingdom",
        "Postal Code": "CW1 6AG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636935,
        "Service/Circuit ID": 889581,
        "Site": "Crewe",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 1065.46,
        "MRC w/tax & fees": 1065.46,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "2 Cowley Way",
        "Address 2": "Weston Road",
        "Abbreviation": "CREWE",
        "City": "Crewe",
        "State/Prov": "Cheshire",
        "Country": "United Kingdom",
        "Postal Code": "CW1 6AG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445210291,
        "Site": "Crewe",
        "Service Type": "DIA",
        "Exp Date": 46354,
        "SO Found": "NA",
        "MRC base": 800,
        "MRC w/tax & fees": 800,
        "Speed (mbps)": 500,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "2 Cowley Way, Weston Road",
        "Address 2": "NA",
        "Abbreviation": "CREWE",
        "City": "Crewe",
        "State/Prov": "Cheshire",
        "Country": "United Kingdom",
        "Postal Code": "CW1 6AG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2554916,
        "Service/Circuit ID": 1071961,
        "Site": "Darmstadt",
        "Service Type": "SDWAN",
        "Exp Date": 46522,
        "SO Found": "NA",
        "MRC base": 1004.6,
        "MRC w/tax & fees": 1004.6,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Guerickeweg 7",
        "Address 2": "NA",
        "Abbreviation": "DAR",
        "City": "Darmstadt",
        "State/Prov": "Hesse",
        "Country": "Germany",
        "Postal Code": 64291
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2554916,
        "Service/Circuit ID": 1071961,
        "Site": "Darmstadt",
        "Service Type": "MPLS",
        "Exp Date": 46522,
        "SO Found": "NA",
        "MRC base": 762.9,
        "MRC w/tax & fees": 1027.15,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Guerickeweg 7",
        "Address 2": "NA",
        "Abbreviation": "DAR",
        "City": "Darmstadt",
        "State/Prov": "Hesse",
        "Country": "Germany",
        "Postal Code": 64291
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "FXIP-MKS-4",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "FBLU1/IPAC/487461-1057544",
        "Site": "Darmstadt",
        "Service Type": "DIA",
        "Exp Date": "Exp 12/12/24",
        "SO Found": "NA",
        "MRC base": 1337.25,
        "MRC w/tax & fees": 1450.92,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "GTT",
        "Address Street/Suite": "Guerickeweg 7",
        "Address 2": "NA",
        "Abbreviation": "DAR",
        "City": "Darmstadt",
        "State/Prov": "Hesse",
        "Country": "Germany",
        "Postal Code": 64291
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445210307,
        "Site": "Darmstadt",
        "Service Type": "DIA",
        "Exp Date": 46430,
        "SO Found": "NA",
        "MRC base": 830,
        "MRC w/tax & fees": 830,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "Guerickeweg 7",
        "Address 2": "NA",
        "Abbreviation": "DAR",
        "City": "Darmstadt",
        "State/Prov": "Hesse",
        "Country": "Germany",
        "Postal Code": 64291
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "1-DOAUO0",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445885263,
        "Site": "Darmstadt",
        "Service Type": "DIA",
        "Exp Date": 46576,
        "SO Found": "NA",
        "MRC base": 1196.1,
        "MRC w/tax & fees": 1196.1,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "Guerickeweg 7",
        "Address 2": "NA",
        "Abbreviation": "DAR",
        "City": "Darmstadt",
        "State/Prov": "Hesse",
        "Country": "Germany",
        "Postal Code": 64291
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 585.8244,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "DETR"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 227.32920000000001,
        "Speed (mbps)": 8,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "DETR"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 555.12,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ERND"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 278.60760000000005,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ERND"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 844.3872000000001,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "FEUC"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 844.3872000000001,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "FEUC"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2515861,
        "Service/Circuit ID": 1072247,
        "Site": "Franklin",
        "Service Type": "SDWAN",
        "Exp Date": 46427,
        "SO Found": "NA",
        "MRC base": 844.6,
        "MRC w/tax & fees": 844.6,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "8 East Forge Parkway",
        "Address 2": "NA",
        "Abbreviation": "FRA",
        "City": "Franklin",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "02038"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2515861,
        "Service/Circuit ID": 1072247,
        "Site": "Franklin",
        "Service Type": "MPLS",
        "Exp Date": 46427,
        "SO Found": "NA",
        "MRC base": 900,
        "MRC w/tax & fees": 1221.53,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "8 East Forge Parkway",
        "Address 2": "NA",
        "Abbreviation": "FRA",
        "City": "Franklin",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "02038"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "IP-MKS-2",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "20.VLXP.092026.CBCL..",
        "Site": "Franklin",
        "Service Type": "DIA",
        "Exp Date": "Exp 10/5/24",
        "SO Found": "NA",
        "MRC base": 960,
        "MRC w/tax & fees": 1041.6,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "Comcast",
        "Address Street/Suite": "8 East Forge Parkway",
        "Address 2": "NA",
        "Abbreviation": "FRA",
        "City": "Franklin",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "02038"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445235776,
        "Site": "Franklin",
        "Service Type": "DIA",
        "Exp Date": 46294,
        "SO Found": "NA",
        "MRC base": 640.6,
        "MRC w/tax & fees": 739.52,
        "Speed (mbps)": 100,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "8 East Forge Parkway",
        "Address 2": "NA",
        "Abbreviation": "FRA",
        "City": "Franklin",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "02038"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 323.028,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GBER"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 447.3036000000001,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GBER"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 541.6416,
        "Speed (mbps)": 40,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GSIN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 456.41880000000003,
        "Speed (mbps)": 40,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GSIN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": 1804511,
        "Service/Circuit ID": 1070157,
        "Site": "Taiwan",
        "Service Type": "SDWAN",
        "Exp Date": 44910,
        "SO Found": "NA",
        "MRC base": 399,
        "MRC w/tax & fees": " ",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Section 2, Guangfu Road 153",
        "Address 2": "NA",
        "Abbreviation": "GUAN",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": 1575578,
        "Service/Circuit ID": 993526,
        "Site": "Taiwan",
        "Service Type": "MPLS",
        "Exp Date": "6/30/22 & 4/1/23",
        "SO Found": "NA",
        "MRC base": 2055,
        "MRC w/tax & fees": 2363.25,
        "Speed (mbps)": 10,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Section 2, Guangfu Road 153",
        "Address 2": "NA",
        "Abbreviation": "GUAN",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1109.3112,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GUAN",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 329.40000000000003,
        "Speed (mbps)": 60,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GUAN",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 3770.1720000000005,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GUNG",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GUNG",
        "City": "East District",
        "Country": "Taiwan",
        "Postal Code": 300
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 0,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GZEQ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 0,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "GZEQ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2509.0884,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HANO"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 410.79960000000005,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HANO"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HARY"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HARY"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2625892,
        "Service/Circuit ID": 2921043,
        "Site": "Haverhill",
        "Service Type": "SDWAN",
        "Exp Date": 46640,
        "SO Found": "NA",
        "MRC base": "bundle below",
        "MRC w/tax & fees": "bundle below",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "55 Foundation Ave",
        "Address 2": "NA",
        "Abbreviation": "HAV",
        "City": "Haverhill",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01835"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2625892,
        "Service/Circuit ID": 2921043,
        "Site": "Haverhill",
        "Service Type": "MPLS",
        "Exp Date": 46640,
        "SO Found": "NA",
        "MRC base": 2042,
        "MRC w/tax & fees": 2434.9900000000002,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "55 Foundation Ave",
        "Address 2": "NA",
        "Abbreviation": "HAVE",
        "City": "Haverhill",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01835"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2509.0884,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HCMC"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 410.79960000000005,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HCMC"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1247.0112000000001,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HUIZ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 8,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "HUIZ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Newport",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344514,
        "Service/Circuit ID": 1072248,
        "Site": "Irvine",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 3375.25,
        "MRC w/tax & fees": 3375.25,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1791 Deere Ave",
        "Address 2": "NA",
        "Abbreviation": "IRV",
        "City": "Irvine",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": 92606
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Newport",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2367634,
        "Service/Circuit ID": 972105,
        "Site": "Irvine",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 3542,
        "MRC w/tax & fees": 3747.3,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1791 Deere Ave",
        "Address 2": "NA",
        "Abbreviation": "IRV",
        "City": "Irvine",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": 92606
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Newport",
        "Billing Account#": "1-CCIOCJ",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442133466,
        "Site": "Irvine",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/4/23",
        "SO Found": "NA",
        "MRC base": 1847.96,
        "MRC w/tax & fees": 1954.21,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "1791 Deere Ave",
        "Address 2": "NA",
        "Abbreviation": "IRV",
        "City": "Irvine",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": 92606
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "IPVPN",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 551.2536,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ISBU"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "IPVPN",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 751.6476000000001,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ISBU"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2419115,
        "Service/Circuit ID": 1134166,
        "Site": "Italy Alter Pwr",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 8/1/23",
        "SO Found": "NA",
        "MRC base": 465.75,
        "MRC w/tax & fees": 465.75,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Via P. e. M. Curie 8",
        "Address 2": "NA",
        "Abbreviation": "ITA",
        "City": "Reggio Emilia",
        "Country": "Italy",
        "Postal Code": 42122
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636820,
        "Service/Circuit ID": 1134158,
        "Site": "Italy Alter Pwr",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 1519.24,
        "MRC w/tax & fees": 1815.99,
        "Speed (mbps)": 10,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Via P. e. M. Curie 8",
        "Address 2": "NA",
        "Abbreviation": "ITA",
        "City": "Reggio Emilia",
        "Country": "Italy",
        "Postal Code": 42122
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 496.09800000000007,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ITEL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 447.3036000000001,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ITEL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 416.88000000000005,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "JABL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 467.1,
        "Speed (mbps)": 40,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "JABL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 3796.8804000000005,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "JAHN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 245.268,
        "Speed (mbps)": 35,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "JAHN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344584,
        "Service/Circuit ID": 1070239,
        "Site": "Jerusalem-Ophir Optronics",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 2063.11,
        "MRC w/tax & fees": 2063.11,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Har Hotzvim Hartom 6",
        "Address 2": "NA",
        "Abbreviation": "JER1",
        "City": "Jerusalem",
        "State/Prov": " ",
        "Country": "Israel",
        "Postal Code": 91450
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636620,
        "Service/Circuit ID": 976690,
        "Site": "Jerusalem-Ophir Optronics",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 2632.35,
        "MRC w/tax & fees": 3334.33,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Har Hotzvim Hartom 6",
        "Address 2": "NA",
        "Abbreviation": "JER1",
        "City": "Jerusalem",
        "State/Prov": " ",
        "Country": "Israel",
        "Postal Code": 91450
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "10042821",
        "Site": "Jerusalem-Ophir Optronics",
        "Service Type": "P2P",
        "Exp Date": "12/31/2025 ?",
        "SO Found": "NA",
        "MRC base": 541,
        "MRC w/tax & fees": 541,
        "Speed (mbps)": 1000,
        "Provider": "HOT",
        "Telco": "HOT",
        "Address Street/Suite": "6 Hartum Street",
        "Address 2": "NA",
        "Abbreviation": "JER2",
        "City": "Jerusalem",
        "Country": "Israel",
        "Postal Code": "9777506"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "10-9001781",
        "Site": "Jerusalem-Ophir Optronics",
        "Service Type": "DIA",
        "Exp Date": "12/31/2025 ?",
        "SO Found": "NA",
        "MRC base": 804,
        "MRC w/tax & fees": 804,
        "Speed (mbps)": 500,
        "Provider": "Partner.co.il",
        "Telco": "Partner.co.il",
        "Address Street/Suite": "6 Hartum Street",
        "Address 2": "NA",
        "Abbreviation": "JER2",
        "City": "Jerusalem",
        "Country": "Israel",
        "Postal Code": "9777506"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 442.206,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KANA"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 356.9724,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KANA"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1519.3116,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KAOH"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 234.8784,
        "Speed (mbps)": 60,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KAOH"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Electro Scientific Industries",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2419275,
        "Service/Circuit ID": 2794401,
        "Site": "Klamath Falls E&S",
        "Service Type": "SDWAN",
        "Exp Date": 46439,
        "SO Found": "NA",
        "MRC base": 820.25,
        "MRC w/tax & fees": 820.25,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "4700 ESI Way",
        "Address 2": "NA",
        "Abbreviation": "KFL",
        "City": "Klamath Falls",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": "97601"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Electro Scientific Industries",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2419275,
        "Service/Circuit ID": 2794401,
        "Site": "Klamath Falls E&S",
        "Service Type": "MPLS",
        "Exp Date": 46439,
        "SO Found": "NA",
        "MRC base": 1190,
        "MRC w/tax & fees": 1490.55,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "4700 ESI Way",
        "Address 2": "NA",
        "Abbreviation": "KFL",
        "City": "Klamath Falls",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": "97601"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445320465,
        "Site": "Klamath Falls E&S",
        "Service Type": "DIA",
        "Exp Date": 46459,
        "SO Found": "NA",
        "MRC base": 1035,
        "MRC w/tax & fees": 1094.94,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "4700 ESI Way",
        "Address 2": "NA",
        "Abbreviation": "KFL",
        "City": "Klamath Falls",
        "State/Prov": "OR",
        "Country": "USA",
        "Postal Code": "97601-9399"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 440.33760000000007,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KOWL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 264.0276,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KOWL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1301.076,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KUAL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 323.17920000000004,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "KUAL"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 230.09400000000002,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "LAIN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 226.8,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "LAIN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2647565,
        "Service/Circuit ID": 2921044,
        "Site": "Lawrence",
        "Service Type": "SDWAN/5G",
        "Exp Date": 46663,
        "SO Found": "NA",
        "MRC base": 1018,
        "MRC w/tax & fees": 1205.82,
        "Speed (mbps)": "200",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "17 Ballard Way",
        "Address 2": "NA",
        "Abbreviation": "LAW",
        "City": "Lawrence",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01843"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 446070787,
        "Site": "Lawrence",
        "Service Type": "DIA",
        "Exp Date": 46587,
        "SO Found": "NA",
        "MRC base": 951,
        "MRC w/tax & fees": 1089.19,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "17 Ballard Waay",
        "Address 2": "NA",
        "Abbreviation": "LAW",
        "City": "Lawrence",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01843"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2345092,
        "Service/Circuit ID": 1072250,
        "Site": "North Logan",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 1700.12,
        "MRC w/tax & fees": 1700.12,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3050 North 300 West",
        "Address 2": "NA",
        "Abbreviation": "LOG",
        "City": "North Logan",
        "State/Prov": "UT",
        "Country": "USA",
        "Postal Code": 84341
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2368273,
        "Service/Circuit ID": 1009608,
        "Site": "North Logan",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 575,
        "MRC w/tax & fees": 1337.71,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3050 North 300 West",
        "Address 2": "NA",
        "Abbreviation": "LOG",
        "City": "North Logan",
        "State/Prov": "UT",
        "Country": "USA",
        "Postal Code": 84341
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Ophir Optronics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636728,
        "Service/Circuit ID": 1326954,
        "Site": "North Logan",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 1911.59,
        "MRC w/tax & fees": 1911.59,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3050 North 300 West",
        "Address 2": "NA",
        "Abbreviation": "LOG",
        "City": "North Logan",
        "State/Prov": "UT",
        "Country": "USA",
        "Postal Code": 84341
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 467.4132000000001,
        "Speed (mbps)": 1,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MACE"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 272.87280000000004,
        "Speed (mbps)": 2,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MACE"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 396.51120000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MERN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 635.0400000000001,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MERN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2652479,
        "Service/Circuit ID": 2921042,
        "Site": "Methuen",
        "Service Type": "SDWAN/5G",
        "Exp Date": 46663,
        "SO Found": "NA",
        "MRC base": 1373,
        "MRC w/tax & fees": 1639.3899999999999,
        "Speed (mbps)": "200/30",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "651 Lowell St",
        "Address 2": "NA",
        "Abbreviation": "MET",
        "City": "Methuen",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01844"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 446070804,
        "Site": "Methuen",
        "Service Type": "DIA",
        "Exp Date": 46515,
        "SO Found": "NA",
        "MRC base": 1470.95,
        "MRC w/tax & fees": 1684.11,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "651 Lowell St",
        "Address 2": "NA",
        "Abbreviation": "MET",
        "City": "Methuen",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01844"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1747795,
        "Service/Circuit ID": 1840115,
        "Site": "Milpitas",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 2/19/24",
        "SO Found": "NA",
        "MRC base": 1867,
        "MRC w/tax & fees": 1867,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1565 Barber Ln",
        "Address 2": "NA",
        "Abbreviation": "MIL",
        "City": "Milpitas",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": "95035-7409"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1747795,
        "Service/Circuit ID": 1840115,
        "Site": "Milpitas",
        "Service Type": "MPLS",
        "Exp Date": "Exp 2/19/24",
        "SO Found": "NA",
        "MRC base": 1399,
        "MRC w/tax & fees": 2085.77,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "NA",
        "Address Street/Suite": "1565 Barber Ln",
        "Address 2": "NA",
        "Abbreviation": "MIL",
        "City": "Milpitas",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": "95035-7409"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "IP-MKS-7",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "BREC794340 ATI",
        "Site": "Milpitas",
        "Service Type": "DIA",
        "Exp Date": "Exp 5/29/24",
        "SO Found": "NA",
        "MRC base": 1280,
        "MRC w/tax & fees": 1388,
        "Speed (mbps)": 250,
        "Provider": "Fastblue",
        "Telco": "AT&T",
        "Address Street/Suite": "1565 Barber Ln",
        "Address 2": "NA",
        "Abbreviation": "MIL",
        "City": "Milpitas",
        "State/Prov": "CA",
        "Country": "USA",
        "Postal Code": 95035
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MNSR"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 129.60000000000002,
        "Speed (mbps)": 40,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "MNSR"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442986840,
        "Site": "Munich",
        "Service Type": "DIA",
        "Exp Date": "Exp 11/3/24",
        "SO Found": "NA",
        "MRC base": 825,
        "MRC w/tax & fees": 825,
        "Speed (mbps)": 300,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "Schatzbogen 43",
        "Address 2": "NA",
        "Abbreviation": "MUN",
        "City": "München",
        "State/Prov": "Bayern",
        "Country": "Germany",
        "Postal Code": 81829
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "1-DOAUO0",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445885343,
        "Site": "Munich",
        "Service Type": "DIA",
        "Exp Date": 46551,
        "SO Found": "NA",
        "MRC base": 586.43,
        "MRC w/tax & fees": 586.43,
        "Speed (mbps)": 500,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "Schatzbogen 43",
        "Address 2": "NA",
        "Abbreviation": "MUN",
        "City": "München",
        "State/Prov": "Bayern",
        "Country": "Germany",
        "Postal Code": 81829
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2515865,
        "Service/Circuit ID": 1070255,
        "Site": "Munich",
        "Service Type": "SDWAN",
        "Exp Date": 45687,
        "SO Found": "NA",
        "MRC base": 984.55,
        "MRC w/tax & fees": 984.55,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Schatzbogen 43",
        "Address 2": "NA",
        "Abbreviation": "MUN",
        "City": "München",
        "State/Prov": "Bayern",
        "Country": "Germany",
        "Postal Code": 81829
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2515865,
        "Service/Circuit ID": 1070255,
        "Site": "Munich",
        "Service Type": "MPLS",
        "Exp Date": 45687,
        "SO Found": "NA",
        "MRC base": 636,
        "MRC w/tax & fees": 878.29,
        "Speed (mbps)": 500,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Schatzbogen 43",
        "Address 2": "NA",
        "Abbreviation": "MUN",
        "City": "München",
        "State/Prov": "Bayern",
        "Country": "Germany",
        "Postal Code": 81829
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1247.0112000000001,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NING"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 542.376,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NING"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1283.4396,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NNJG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 16,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NNJG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2610284,
        "Service/Circuit ID": 1072003,
        "Site": "Nogales",
        "Service Type": "SDWAN",
        "Exp Date": 46600,
        "SO Found": "NA",
        "MRC base": 864.15,
        "MRC w/tax & fees": 864.15,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Parque Industrial Nuevo Nogales",
        "Address 2": "NA",
        "Abbreviation": "NOG",
        "City": "Nogales",
        "State/Prov": "Sonora",
        "Country": "Mexico",
        "Postal Code": 84009
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636510,
        "Service/Circuit ID": 920378,
        "Site": "Nogales",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 4387.25,
        "MRC w/tax & fees": 5564.63,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Parque Industrial Nuevo Nogales",
        "Address 2": "NA",
        "Abbreviation": "NOG",
        "City": "Nogales",
        "State/Prov": "Sonora",
        "Country": "Mexico",
        "Postal Code": 84009
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2610284,
        "Service/Circuit ID": 1072003,
        "Site": "Nogales",
        "Service Type": "DIA",
        "Exp Date": "Exp 8/1/24",
        "SO Found": "NA",
        "MRC base": 2624,
        "MRC w/tax & fees": 2624,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Parque Industrial Nuevo Nogales",
        "Address 2": "NA",
        "Abbreviation": "NOG",
        "City": "Nogales",
        "State/Prov": "Sonora",
        "Country": "Mexico",
        "Postal Code": 84009
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": 20181024,
        "Service/Circuit ID": 3011968,
        "Site": "Nogales",
        "Service Type": "Ethernet P2P",
        "Exp Date": 44641,
        "SO Found": "NA",
        "MRC base": 2390,
        "MRC w/tax & fees": " ",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Parque Industrial Nuevo Nogales",
        "Address 2": "NA",
        "Abbreviation": "NOG",
        "City": "Nogales",
        "State/Prov": "Sonora",
        "Country": "Mexico",
        "Postal Code": 84009
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "FRO2007206087 & FRO2007206086UNI",
        "Site": "Nogales",
        "Service Type": "Burstable DIA",
        "Exp Date": "Exp 8/13/24",
        "SO Found": "NA",
        "MRC base": 2191.6,
        "MRC w/tax & fees": 2191.6,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "Parque Industrial Nuevo Nogales",
        "Address 2": "NA",
        "Abbreviation": "NOG",
        "City": "Nogales",
        "State/Prov": "Sonora",
        "Country": "Mexico",
        "Postal Code": 84009
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 438.46920000000006,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NORK"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 307.692,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "NORK"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 397.9152,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "OLAV"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1029.4884000000002,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "OLAV"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Newport",
        "Billing Account#": 60012740,
        "Order ID/Account #": 60012740,
        "Service/Circuit ID": "NPC-0001",
        "Site": "Osaka",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/30/17",
        "SO Found": "NA",
        "MRC base": 440,
        "MRC w/tax & fees": 440,
        "Speed (mbps)": 10,
        "Provider": "TELSTRA SERVICES ASIA PACIFIC HK LT",
        "Telco": "TELSTRA SERVICES ASIA PACIFIC HK LT",
        "Address Street/Suite": "Solar Building; 3-1-43 Nishihon-machi, Nishi-ku",
        "Address 2": "NA",
        "Abbreviation": "OSA",
        "City": "Osaka",
        "Country": "Japan",
        "Postal Code": "550-0005"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442904628,
        "Site": "Plano ",
        "Service Type": "DIA",
        "Exp Date": "Exp 3/17/24",
        "SO Found": "NA",
        "MRC base": 1220.19,
        "MRC w/tax & fees": 1296.03,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "3500 E Plano Pkwy",
        "Address 2": "NA",
        "Abbreviation": "PLAN",
        "City": "Plano",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": " 75074-7205"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 446174133,
        "Site": "Plano ",
        "Service Type": "DIA",
        "Exp Date": 46528,
        "SO Found": "NA",
        "MRC base": 2164,
        "MRC w/tax & fees": 2298.49,
        "Speed (mbps)": 2000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "3500 E Plano Pkwy",
        "Address 2": "NA",
        "Abbreviation": "PLAN",
        "City": "Plano",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": " 75074-7205"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2147688,
        "Service/Circuit ID": 2167923,
        "Site": "Plano",
        "Service Type": "SDWAN",
        "Exp Date": 45907,
        "SO Found": "NA",
        "MRC base": 1491,
        "MRC w/tax & fees": 1491,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3500 E Plano Pkwy",
        "Address 2": "NA",
        "Abbreviation": "PLAN",
        "City": "Plano",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 75074
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2147688,
        "Service/Circuit ID": 2167923,
        "Site": "Plano",
        "Service Type": "MPLS",
        "Exp Date": 45907,
        "SO Found": "NA",
        "MRC base": 1724,
        "MRC w/tax & fees": 2612.78,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3500 E Plano Pkwy",
        "Address 2": "NA",
        "Abbreviation": "PLAN",
        "City": "Plano",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 75074
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2147688,
        "Service/Circuit ID": 2167923,
        "Site": "Plano",
        "Service Type": "MPLS",
        "Exp Date": 45907,
        "SO Found": "NA",
        "MRC base": 1800,
        "MRC w/tax & fees": 1800,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "3500 E Plano Pkwy",
        "Address 2": "NA",
        "Abbreviation": "PLAN",
        "City": "Plano",
        "State/Prov": "TX",
        "Country": "USA",
        "Postal Code": 75074
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 517.374,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PLCC"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 517.374,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PLCC"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Plasmart",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344787,
        "Service/Circuit ID": 1070150,
        "Site": "Korea Plasmart",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 832.66,
        "MRC w/tax & fees": 832.66,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Yuseong -543",
        "Address 2": "NA",
        "Abbreviation": "PLT1",
        "City": "Yuseong-Gu",
        "Country": "South Korea",
        "Postal Code": "305-500"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Plasmart",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636566,
        "Service/Circuit ID": 976687,
        "Site": "Korea Plasmart",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 3214.17,
        "MRC w/tax & fees": 3819.15,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Yuseong -543",
        "Address 2": "NA",
        "Abbreviation": "PLT1",
        "City": "Yuseong-Gu",
        "Country": "South Korea",
        "Postal Code": "305-500"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2009819,
        "Service/Circuit ID": 2269504,
        "Site": "Korea R&D Center",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 9/10/24",
        "SO Found": "NA",
        "MRC base": 884,
        "MRC w/tax & fees": 884,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "16 Techno 5th St",
        "Address 2": "NA",
        "Abbreviation": "PLT1",
        "City": "Yuseong-gu",
        "State/Prov": "Daejeon",
        "Country": "South Korea",
        "Postal Code": 34025
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2009819,
        "Service/Circuit ID": 2269504,
        "Site": "Korea R&D Center",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/10/24",
        "SO Found": "NA",
        "MRC base": 2041,
        "MRC w/tax & fees": 2478.29,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "16 Techno 5th St",
        "Address 2": "NA",
        "Abbreviation": "PLT1",
        "City": "Yuseong-gu",
        "State/Prov": "Daejeon",
        "Country": "South Korea",
        "Postal Code": 34025
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 936.7164000000001,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PNNG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1991.5200000000002,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PNNG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 505.58040000000005,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PODN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 493.16040000000004,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PODN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 315.1548,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "POZN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 560.52,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "POZN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2479347,
        "Service/Circuit ID": "2854227",
        "Site": "Thailand",
        "Service Type": "SDWAN",
        "Exp Date": 46531,
        "SO Found": "NA",
        "MRC base": 445.98,
        "MRC w/tax & fees": 512.66,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Anuson Thongpathomvong 53/5-6",
        "Address 2": "NA",
        "Abbreviation": "PTHU",
        "City": "Tambon Kholong Song",
        "Country": "Thailand",
        "Postal Code": 12120
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 788.6160000000001,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PTHU",
        "City": "Tambon Kholong Song",
        "Country": "Thailand",
        "Postal Code": 12121
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 788.6160000000001,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "PTHU",
        "City": "Tambon Kholong Song",
        "Country": "Thailand",
        "Postal Code": 12122
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1283.4396,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "QING"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 6,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "QING"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1363.7916,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "QUAT"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1262.25,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "QUAT"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2600144,
        "Service/Circuit ID": 2975929,
        "Site": "Queretaro",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 10/31/24",
        "SO Found": "NA",
        "MRC base": "NA",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "aV. 5 de Febrero 1351",
        "Address 2": "NA",
        "Abbreviation": "QUAT 2",
        "City": "Santiago de Queretaro",
        "Country": "Mexico",
        "Postal Code": 76120
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2600144,
        "Service/Circuit ID": 2975929,
        "Site": "Queretaro",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 10/31/24",
        "SO Found": "NA",
        "MRC base": "NA",
        "Speed (mbps)": 500,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "aV. 5 de Febrero 1351",
        "Address 2": "NA",
        "Abbreviation": "QUAT 2",
        "City": "Santiago de Queretaro",
        "Country": "Mexico",
        "Postal Code": 76120
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2600144,
        "Service/Circuit ID": 2975929,
        "Site": "Queretaro",
        "Service Type": "SDWAN",
        "Exp Date": 45596,
        "SO Found": "NA",
        "MRC base": "NA",
        "Speed (mbps)": 500,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "aV. 5 de Febrero 1351",
        "Address 2": "NA",
        "Abbreviation": "QUAT 2",
        "City": "Santiago de Queretaro",
        "Country": "Mexico",
        "Postal Code": 76120
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2600144,
        "Service/Circuit ID": 2975929,
        "Site": "Queretaro",
        "Service Type": "SDWAN",
        "Exp Date": 45596,
        "SO Found": "NA",
        "MRC base": "NA",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "aV. 5 de Febrero 1351",
        "Address 2": "NA",
        "Abbreviation": "QUAT 2 ",
        "City": "Santiago de Queretaro",
        "Country": "Mexico",
        "Postal Code": 76120
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392464,
        "Service/Circuit ID": 1115992,
        "Site": "Rankweil",
        "Service Type": "SDWAN",
        "Exp Date": 46688,
        "SO Found": "NA",
        "MRC base": 1085.1,
        "MRC w/tax & fees": 1085.1,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Feldgut 9",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Rankweil",
        "Country": "Austria",
        "Postal Code": 6830
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344607,
        "Service/Circuit ID": 1115989,
        "Site": "Rankweil",
        "Service Type": "MPLS",
        "Exp Date": "7/31/22 & 4/1/23",
        "SO Found": "NA",
        "MRC base": 1867.6,
        "MRC w/tax & fees": 2579.16,
        "Speed (mbps)": "20 ?",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Feldgut 9",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Rankweil",
        "Country": "Austria",
        "Postal Code": 6830
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392464,
        "Service/Circuit ID": 1115992,
        "Site": "Rankweil",
        "Service Type": "DIA?",
        "Exp Date": 46688,
        "SO Found": "NA",
        "MRC base": 1806.72,
        "MRC w/tax & fees": 1806.72,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Feldgut 9",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Rankweil",
        "Country": "Austria",
        "Postal Code": 6830
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "FXIP-MKS-5",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "Circuit ID: FBLU1/IPAC/494405,\r\nGTT Service = DIA/01301401, ALT ID: Hutchison 01-00-0574523-1011\r\nID: 1044352-2969828",
        "Site": "Rankweil",
        "Service Type": "DIA",
        "Exp Date": 45694,
        "SO Found": "NA",
        "MRC base": 2042.02,
        "MRC w/tax & fees": 2215.59,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "GTT/Hutchison",
        "Address Street/Suite": "Feldgut 9",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Rankweil",
        "Country": "Austria",
        "Postal Code": 6830
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344942,
        "Service/Circuit ID": 1070298,
        "Site": "Vienna",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 531.24,
        "MRC w/tax & fees": 531.24,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Fernkorngasse 10",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Wien",
        "Country": "Austria",
        "Postal Code": 1100
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2637081,
        "Service/Circuit ID": 972081,
        "Site": "Vienna",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 658.09,
        "MRC w/tax & fees": 916.48,
        "Speed (mbps)": 10,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Fernkorngasse 10",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Wien",
        "Country": "Austria",
        "Postal Code": 1100
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2637143,
        "Service/Circuit ID": 1384966,
        "Site": "Vienna",
        "Service Type": "DIA",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 539.14,
        "MRC w/tax & fees": 539.14,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Fernkorngasse 10",
        "Address 2": "NA",
        "Abbreviation": "RAN",
        "City": "Wien",
        "Country": "Austria",
        "Postal Code": 1100
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "21892",
        "Site": "Rehovot",
        "Service Type": "P2P",
        "Exp Date": " ",
        "SO Found": "NA",
        "MRC base": 1027,
        "MRC w/tax & fees": 1027,
        "Speed (mbps)": 2000,
        "Provider": "HOT",
        "Telco": "HOT",
        "Address Street/Suite": "Prof. Hillel and Hanan Oppenheimer St 4",
        "Address 2": "Beit Ogen 10th Floor",
        "Abbreviation": "RHVT",
        "City": "Rehovot",
        "Country": "Israel",
        "Postal Code": "7670104"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "3330000341",
        "Site": "Rehovot",
        "Service Type": "DIA",
        "Exp Date": " ",
        "SO Found": "NA",
        "MRC base": 973,
        "MRC w/tax & fees": 973,
        "Speed (mbps)": 1000,
        "Provider": "Cellcom",
        "Telco": "Cellcom",
        "Address Street/Suite": "Prof. Hillel and Hanan Oppenheimer St 4",
        "Address 2": "Beit Ogen 10th Floor",
        "Abbreviation": "RHVT",
        "City": "Rehovot",
        "Country": "Israel",
        "Postal Code": "7670104"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "3330003509",
        "Site": "Rehovot",
        "Service Type": "DIA",
        "SO Found": "NA",
        "MRC base": 209,
        "MRC w/tax & fees": 209,
        "Speed (mbps)": 50,
        "Provider": "Cellcom",
        "Telco": "Cellcom",
        "Address Street/Suite": "Prof. Hillel and Hanan Oppenheimer St 4",
        "Address 2": "Beit Ogen 10th Floor",
        "Abbreviation": "RHVT",
        "City": "Rehovot",
        "Country": "Israel",
        "Postal Code": "7670104"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2345094,
        "Service/Circuit ID": 1125244,
        "Site": "Rehovot",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 1620.35,
        "MRC w/tax & fees": 1620.35,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Prof. Hillel and Hanan Oppenheimer St 4",
        "Address 2": "Beit Ogen 10th Floor",
        "Abbreviation": "RHVT",
        "City": "Rehovot",
        "Country": "Israel",
        "Postal Code": 7670104
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "Spectra Physics",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2608859,
        "Service/Circuit ID": 972063,
        "Site": "Rehovot",
        "Service Type": "MPLS",
        "Exp Date": "Exp 7/28/24",
        "SO Found": "NA",
        "MRC base": 2066.5,
        "MRC w/tax & fees": 2617.68,
        "Speed (mbps)": 50,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Prof. Hillel and Hanan Oppenheimer St 4",
        "Address 2": "Beit Ogen 10th Floor",
        "Abbreviation": "RHVT",
        "City": "Rehovot",
        "Country": "Israel",
        "Postal Code": 7670104
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "1-DOAUO0",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442249363,
        "Site": "Rochester-Highpower",
        "Service Type": "DIA",
        "Exp Date": 45860,
        "SO Found": "NA",
        "MRC base": 3282.34,
        "MRC w/tax & fees": 3764.25,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "100 Highpower Rd",
        "Address 2": "NA",
        "Abbreviation": "ROC-H",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": " 14623-3434"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445124432,
        "Site": "Rochester-Highpower",
        "Service Type": "DIA",
        "Exp Date": 46312,
        "SO Found": "NA",
        "MRC base": 2633.52,
        "MRC w/tax & fees": 3048.21,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "100 Highpower Rd",
        "Address 2": "NA",
        "Abbreviation": "ROC-H",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": " 14623-3434"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392481,
        "Service/Circuit ID": 2052286,
        "Site": "Rochester-Highpower",
        "Service Type": "SDWAN",
        "Exp Date": 46471,
        "SO Found": "NA",
        "MRC base": 1025,
        "MRC w/tax & fees": 1025,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "100 Highpower Rd",
        "Address 2": "NA",
        "Abbreviation": "ROC-H",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14623-3434"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392481,
        "Service/Circuit ID": 2052286,
        "Site": "Rochester-Highpower",
        "Service Type": "MPLS",
        "Exp Date": 46471,
        "SO Found": "NA",
        "MRC base": 1780,
        "MRC w/tax & fees": 2291.34,
        "Speed (mbps)": 1000,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "100 Highpower Rd",
        "Address 2": "NA",
        "Abbreviation": "ROC-H",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14623-3434"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392439,
        "Service/Circuit ID": 1072252,
        "Site": "Rochester-Linden",
        "Service Type": "SDWAN",
        "Exp Date": 46355,
        "SO Found": "NA",
        "MRC base": 1067.85,
        "MRC w/tax & fees": 1067.85,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "820 Linden Ave",
        "Address 2": "NA",
        "Abbreviation": "ROC-LIN",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14625-2710"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2368305,
        "Service/Circuit ID": 972109,
        "Site": "Rochester-Linden",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 1015.45,
        "MRC w/tax & fees": 1584.45,
        "Speed (mbps)": 10,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "820 Linden Ave",
        "Address 2": "NA",
        "Abbreviation": "ROC-LIN",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14625-2710"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392439,
        "Service/Circuit ID": 1072252,
        "Site": "Rochester-Linden",
        "Service Type": "DIA",
        "Exp Date": 46355,
        "SO Found": "NA",
        "MRC base": 1065.46,
        "MRC w/tax & fees": 1065.46,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "820 Linden Ave",
        "Address 2": "NA",
        "Abbreviation": "ROC-LIN",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14625-2710"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "IP-MKS-1",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "BDMQ5332",
        "Site": "Rochester-Linden",
        "Service Type": "DIA",
        "Exp Date": 45556,
        "SO Found": "NA",
        "MRC base": 700,
        "MRC w/tax & fees": 796.7,
        "Speed (mbps)": 100,
        "Provider": "Fastblue",
        "Telco": "Lumen",
        "Address Street/Suite": "820 Linden Ave",
        "Address 2": "NA",
        "Abbreviation": "ROC-LIN",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14625-2710"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445155401,
        "Site": "Rochester-Linden",
        "Service Type": "DIA",
        "Exp Date": 46263,
        "SO Found": "NA",
        "MRC base": 719,
        "MRC w/tax & fees": 771.34,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "820 Linden Ave",
        "Address 2": "NA",
        "Abbreviation": "ROC-LIN",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14625-2710"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 205332178,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 445235454,
        "Site": "Rochester-Saint Paul",
        "Service Type": "DIA",
        "Exp Date": 46508,
        "SO Found": "NA",
        "MRC base": 1300.62,
        "MRC w/tax & fees": 1504.95,
        "Speed (mbps)": 200,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "707 St Paul Street",
        "Address 2": "NA",
        "Abbreviation": "ROC-STP",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": 14605
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2532563,
        "Service/Circuit ID": 1072251,
        "Site": "Rochester-Saint Paul",
        "Service Type": "SDWAN",
        "Exp Date": 46468,
        "SO Found": "NA",
        "MRC base": 1090.19,
        "MRC w/tax & fees": 1090.19,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "705 St Paul St",
        "Address 2": "NA",
        "Abbreviation": "ROC-STP",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14605-1730"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636800,
        "Service/Circuit ID": 1327906,
        "Site": "Rochester-Saint Paul",
        "Service Type": "DIA",
        "Exp Date": "Exp 1/1/24",
        "SO Found": "NA",
        "MRC base": 1540.55,
        "MRC w/tax & fees": 1540.55,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "705 St Paul St",
        "Address 2": "NA",
        "Abbreviation": "ROC-STP",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14605-1730"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2532563,
        "Service/Circuit ID": 1072251,
        "Site": "Rochester-Saint Paul",
        "Service Type": "DIA",
        "Exp Date": 46468,
        "SO Found": "NA",
        "MRC base": 1887.74,
        "MRC w/tax & fees": 2549.5299999999997,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "705 St Paul St",
        "Address 2": "NA",
        "Abbreviation": "ROC-STP",
        "City": "Rochester",
        "State/Prov": "NY",
        "Country": "USA",
        "Postal Code": "14605-1730"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "446611463 aka SC/KXFN/095540/LUMN",
        "Site": "Rock Hill",
        "Service Type": "Naas",
        "Exp Date": 46657,
        "SO Found": "NA",
        "MRC base": 250,
        "MRC w/tax & fees": 418.97,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "1750 Overview Drive",
        "Address 2": "NA",
        "Abbreviation": "ROCK",
        "City": "Rock Hill",
        "State/Prov": "SC",
        "Country": "USA",
        "Postal Code": 29730
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 522.0612,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ROCK"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 571.32,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ROCK"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2418253,
        "Service/Circuit ID": 1678303,
        "Site": "Shanghai E&S",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 8/1/23",
        "SO Found": "NA",
        "MRC base": "w/MPLS below",
        "MRC w/tax & fees": "w/MPLS below",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Room 107, Building E",
        "Address 2": "139 Fa​nghua Road, Pudong New District",
        "Abbreviation": "SHA",
        "City": "Shanghai",
        "Country": "China",
        "Postal Code": 201204
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2418253,
        "Service/Circuit ID": 1678303,
        "Site": "Shanghai E&S",
        "Service Type": "MPLS",
        "Exp Date": "Exp 8/1/23",
        "SO Found": "NA",
        "MRC base": 4585.05,
        "MRC w/tax & fees": 6062.85,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Room 107, Building E",
        "Address 2": "139 Fa​nghua Road, Pudong New District",
        "Abbreviation": "SHA",
        "City": "Shanghai",
        "Country": "China",
        "Postal Code": 201204
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2014665,
        "Service/Circuit ID": 1963105,
        "Site": "Shanghai E&S",
        "Service Type": "DIA",
        "Exp Date": "Exp 4/1/24",
        "SO Found": "NA",
        "MRC base": 5300,
        "MRC w/tax & fees": 5300,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Room 107, Building E",
        "Address 2": "139 Fa​nghua Road, Pudong New District",
        "Abbreviation": "SHA",
        "City": "Shanghai",
        "Country": "China",
        "Postal Code": 201204
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2368300,
        "Service/Circuit ID": 1069743,
        "Site": "Shenzhen",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 742.41,
        "MRC w/tax & fees": 742.41,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "HongXiang Industrial Park",
        "Address 2": "Hezhou New Village Rd    ",
        "Abbreviation": "SHE",
        "City": "Shenzhen",
        "Country": "China",
        "Postal Code": 518103
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344380,
        "Service/Circuit ID": 1123708,
        "Site": "Shenzhen",
        "Service Type": "MPLS",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 5175,
        "MRC w/tax & fees": 6059.64,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "HongXiang Industrial Park",
        "Address 2": "Hezhou New Village Rd    ",
        "Abbreviation": "SHE",
        "City": "Shenzhen",
        "Country": "China",
        "Postal Code": 518103
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2053544,
        "Service/Circuit ID": 1333862,
        "Site": "Shenzhen",
        "Service Type": "DIA",
        "Exp Date": 45678,
        "SO Found": "NA",
        "MRC base": 4160,
        "MRC w/tax & fees": 4781.92,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "HongXiang Industrial Park",
        "Address 2": "Hezhou New Village Rd    ",
        "Abbreviation": "SHE",
        "City": "Shenzhen",
        "Country": "China",
        "Postal Code": 511700
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2530509,
        "Service/Circuit ID": 2412968,
        "Site": "Singapore KitKat E&S",
        "Service Type": "SDWAN",
        "Exp Date": 45678,
        "SO Found": "NA",
        "MRC base": "w/DIA below",
        "MRC w/tax & fees": "w/DIA below",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1 Kaki Bukit View",
        "Address 2": "#02-05/07 Techview",
        "Abbreviation": "SNG",
        "City": "Singapore",
        "Country": "Singapore",
        "Postal Code": 415941
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636781,
        "Service/Circuit ID": 1554533,
        "Site": "Singapore KitKat E&S",
        "Service Type": "MPLS",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 1746.73,
        "MRC w/tax & fees": 2658.58,
        "Speed (mbps)": 50,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1 Kaki Bukit View",
        "Address 2": "#02-05/07 Techview",
        "Abbreviation": "SNG",
        "City": "Singapore",
        "Country": "Singapore",
        "Postal Code": 415941
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2530509,
        "Service/Circuit ID": 2412968,
        "Site": "Singapore KitKat E&S",
        "Service Type": "DIA",
        "Exp Date": 45678,
        "SO Found": "NA",
        "MRC base": 4352.48,
        "MRC w/tax & fees": 4352.48,
        "Speed (mbps)": 200,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "1 Kaki Bukit View",
        "Address 2": "#02-05/07 Techview",
        "Abbreviation": "SNG",
        "City": "Singapore",
        "Country": "Singapore",
        "Postal Code": 415941
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "SNGA"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2467.5948000000003,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "SNGA"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 0,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "SPOR"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 0,
        "Speed (mbps)": 50,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "SPOR"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344935,
        "Service/Circuit ID": 1071971,
        "Site": "Stahnsdorf",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 529,
        "MRC w/tax & fees": 529,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Ruhlsdorfer Str. 95",
        "Address 2": "NA",
        "Abbreviation": "STA",
        "City": "Stahnsdorf",
        "Country": "Germany",
        "Postal Code": 14532
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2345134,
        "Service/Circuit ID": 1325804,
        "Site": "Stahnsdorf",
        "Service Type": "MPLS",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 1190.14,
        "MRC w/tax & fees": 1447.15,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Ruhlsdorfer Str. 95",
        "Address 2": "NA",
        "Abbreviation": "STA",
        "City": "Stahnsdorf",
        "Country": "Germany",
        "Postal Code": 14532
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 879.174,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TABO"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1015.8048,
        "Speed (mbps)": 30,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TABO"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "1596999-4867285",
        "Service/Circuit ID": "GTT/001853983",
        "Site": "Taiwan",
        "Service Type": "SDWAN",
        "Exp Date": 45179,
        "SO Found": "NA",
        "MRC base": 1900,
        "MRC w/tax & fees": " ",
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Section 2, Guangfu Road 153",
        "Address 2": "Suite 5",
        "Abbreviation": "TAI",
        "City": "Hsinchu County",
        "Country": "Taiwan",
        "Postal Code": 302
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": 1778012,
        "Service/Circuit ID": 1853983,
        "Site": "Taiwan",
        "Service Type": "DIA",
        "Exp Date": 45179,
        "SO Found": "NA",
        "MRC base": 1400,
        "MRC w/tax & fees": 3775,
        "Speed (mbps)": "50 or 100??",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Section 2, Guangfu Road 153",
        "Address 2": "Suite 5",
        "Abbreviation": "TAI",
        "City": "Hsinchu County",
        "Country": "Taiwan",
        "Postal Code": 302
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2147.7312,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TAOY"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 444.15000000000003,
        "Speed (mbps)": 80,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TAOY"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1283.4396,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TIAN"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TIAN"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2344588,
        "Service/Circuit ID": 1070074,
        "Site": "Toyko-Colt DC",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 2055.06,
        "MRC w/tax & fees": 2055.06,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "12-20-1 Shiohama building",
        "Address 2": "Shiohama, Koto-ku",
        "Abbreviation": "TOK 1",
        "City": "Tokyo",
        "Country": "Japan",
        "Postal Code": "135-0043"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2367632,
        "Service/Circuit ID": 972050,
        "Site": "Toyko-Colt DC",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 1531.8,
        "MRC w/tax & fees": 2068.04,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "12-20-1 Shiohama building",
        "Address 2": "Shiohama, Koto-ku",
        "Abbreviation": "TOK 1",
        "City": "Tokyo",
        "Country": "Japan",
        "Postal Code": "135-0043"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 690.3036,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TPEI"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 304.48440000000005,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TPEI"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 565.4664000000001,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TREB"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 957.8952000000002,
        "Speed (mbps)": 100,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "TREB"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2147693,
        "Service/Circuit ID": 2425098,
        "Site": "Vancouver",
        "Service Type": "SDWAN",
        "Exp Date": 45885,
        "SO Found": "NA",
        "MRC base": 1254,
        "MRC w/tax & fees": 1441.48,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "13500 VERDUN PL",
        "Address 2": "Suite 130",
        "Abbreviation": "VAN",
        "City": "Richmond",
        "State/Prov": "BC",
        "Country": "Canada",
        "Postal Code": "V6V 1V2"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 435.92040000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WANT"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 250.4952,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WANT"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 364.8564,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WBRM"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 426.6,
        "Speed (mbps)": 20,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WBRM"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1283.4396,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WENZ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 8,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WENZ"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 470.92320000000007,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WERD"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 331.50600000000003,
        "Speed (mbps)": 100,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "WERD"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392499,
        "Service/Circuit ID": 1072014,
        "Site": "Wilmington",
        "Service Type": "SDWAN",
        "Exp Date": 46446,
        "SO Found": "NA",
        "MRC base": 1960.1,
        "MRC w/tax & fees": 1960.1,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "90 Industrial Way",
        "Address 2": "NA",
        "Abbreviation": "WIL",
        "City": "Wilmington",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01887"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2368401,
        "Service/Circuit ID": 972100,
        "Site": "Wilmington",
        "Service Type": "MPLS",
        "Exp Date": "Exp 5/1/23",
        "SO Found": "NA",
        "MRC base": 1518,
        "MRC w/tax & fees": 2371.25,
        "Speed (mbps)": 100,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "90 Industrial Way",
        "Address 2": "NA",
        "Abbreviation": "WIL",
        "City": "Wilmington",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01887"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2392499,
        "Service/Circuit ID": 1072014,
        "Site": "Wilmington",
        "Service Type": "DIA",
        "Exp Date": 46446,
        "SO Found": "NA",
        "MRC base": 1306,
        "MRC w/tax & fees": 1306,
        "Speed (mbps)": 500,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "90 Industrial Way",
        "Address 2": "NA",
        "Abbreviation": "WIL",
        "City": "Wilmington",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01887"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": 454922,
        "Order ID/Account #": "NA",
        "Service/Circuit ID": 442977291,
        "Site": "Wilmington",
        "Service Type": "DIA",
        "Exp Date": "Exp 8/26/24",
        "SO Found": "NA",
        "MRC base": 3444.33,
        "MRC w/tax & fees": 4152.79,
        "Speed (mbps)": 1000,
        "Provider": "Lumen",
        "Telco": "Lumen",
        "Address Street/Suite": "90 Industrial Way",
        "Address 2": "NA",
        "Abbreviation": "WIL",
        "City": "Wilmington",
        "State/Prov": "MA",
        "Country": "USA",
        "Postal Code": "01887"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2345193,
        "Service/Circuit ID": 1070180,
        "Site": "Wuxi",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 4/1/23",
        "SO Found": "NA",
        "MRC base": 947.6,
        "MRC w/tax & fees": 947.6,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Lot J3-8, Wuxi Export Processing Zone",
        "Address 2": "NA",
        "Abbreviation": "WUX",
        "City": "Jiangsu",
        "Country": "China",
        "Postal Code": 214028
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2300863,
        "Service/Circuit ID": 1123707,
        "Site": "Wuxi",
        "Service Type": "MPLS",
        "Exp Date": "Exp 10/13/23",
        "SO Found": "NA",
        "MRC base": 4707.69,
        "MRC w/tax & fees": 5553.15,
        "Speed (mbps)": 50,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "Lot J3-8, Wuxi Export Processing Zone",
        "Address 2": "NA",
        "Abbreviation": "WUX",
        "City": "Jiangsu",
        "Country": "China",
        "Postal Code": 214028
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1228.7916,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "XIAM"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 6,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "XIAM"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 2467.5948000000003,
        "Speed (mbps)": 10,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "YANG"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 30,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "YANG"
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 1686497,
        "Service/Circuit ID": 1070144,
        "Site": "Yongin",
        "Service Type": "SDWAN",
        "Exp Date": "Exp 10/31/22",
        "SO Found": "NA",
        "MRC base": 1402,
        "MRC w/tax & fees": 1402,
        "Speed (mbps)": "NA",
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "6th Fl., Leader's Tower, 12, Wongomae-Ro, Giheung-Gu",
        "Address 2": "NA",
        "Abbreviation": "YON",
        "City": "Yongin-si",
        "State/Prov": "Gyeonggi-Do",
        "Country": "South Korea",
        "Postal Code": 17086
      },
      {
        "Business Unit": "MKS",
        "Division (if not MKS)": "NA",
        "Billing Account#": "T116088",
        "Order ID/Account #": 2636541,
        "Service/Circuit ID": 1325806,
        "Site": "Yongin",
        "Service Type": "MPLS",
        "Exp Date": "Exp 9/1/24",
        "SO Found": "NA",
        "MRC base": 3646.71,
        "MRC w/tax & fees": 4401.49,
        "Speed (mbps)": 20,
        "Provider": "GTT",
        "Telco": "GTT",
        "Address Street/Suite": "6th Fl., Leader's Tower, 12, Wongomae-Ro, Giheung-Gu",
        "Address 2": "NA",
        "Abbreviation": "YON",
        "City": "Yongin-si",
        "State/Prov": "Gyeonggi-Do",
        "Country": "South Korea",
        "Postal Code": 17086
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1228.7916,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ZHAO"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 6,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ZHAO"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "MPLS",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 1228.7916,
        "Speed (mbps)": 4,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ZHON"
      },
      {
        "Business Unit": "MSD",
        "Division (if not MKS)": "NA",
        "Billing Account#": "NA",
        "Order ID/Account #": "NA",
        "Service/Circuit ID": "NA",
        "Site": "NA",
        "Service Type": "Internet",
        "Exp Date": "NA",
        "SO Found": "NA",
        "MRC base": "NA",
        "MRC w/tax & fees": 269.10360000000003,
        "Speed (mbps)": 8,
        "Provider": "NA",
        "Telco": "NA",
        "Address Street/Suite": "NA",
        "Address 2": "NA",
        "Abbreviation": "ZHON"
      }
    ]
  }